export default "__VITE_ASSET__DaFoxOAz__"